import { heroStats, heroQuickLinks } from "@/mocks/siteContent";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50">
      <div className="absolute inset-0 hero-glow pointer-events-none"></div>
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-accent-200/40 blur-3xl pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-8 lg:px-12 pt-10 md:pt-16 pb-12 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* left : text */}
          <div className="w-full">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-label mb-5">
              <i className="ri-pushpin-2-line"></i>
              个人资料 · 最新动态 · 八卦黑料 · 持续更新
            </span>

            <h1 className="font-heading font-black text-foreground-950 leading-tight text-3xl md:text-5xl lg:text-[3.4rem]">
              夏目彩春
              <span className="block mt-1 text-primary-600">最新动态追踪</span>
            </h1>

            <p className="mt-5 text-foreground-700 text-sm md:text-base leading-relaxed max-w-xl">
              这是一个围绕<strong className="text-foreground-950 font-semibold">夏目彩春</strong>的公开信息整理站：
              把她的<strong className="text-foreground-950 font-semibold">个人资料</strong>、
              <strong className="text-foreground-950 font-semibold">ins 账号线索</strong>、
              <strong className="text-foreground-950 font-semibold">最新动态</strong>与
              <strong className="text-foreground-950 font-semibold">八卦黑料</strong>汇总在一页。
              无论你是想弄清她的真实信息，还是单纯吃瓜围观，都能在这里找到线索与讨论方向。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#profile"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-id-card-line"></i>
                查看个人资料
              </a>
              <a
                href="#gossip"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-chat-smile-2-line"></i>
                围观八卦热议
              </a>
            </div>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {heroStats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200 bg-background-50 p-3"
                >
                  <div className="font-heading font-bold text-xl md:text-2xl text-primary-600">
                    {s.value}
                    <span className="text-xs text-foreground-500 font-body ml-0.5">
                      {s.suffix}
                    </span>
                  </div>
                  <div className="text-xs text-foreground-600 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap gap-x-4 gap-y-2">
              {heroQuickLinks.map((l) => (
                <a
                  key={l.target}
                  href={`#${l.target}`}
                  className="inline-flex items-center gap-1.5 text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  <i className={l.icon}></i>
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          {/* right : image */}
          <div className="w-full">
            <div className="relative w-full">
              <div className="w-full h-[360px] md:h-[520px] rounded-2xl overflow-hidden border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20stylized%20portrait%20of%20a%20woman%20in%20profile%20silhouette%2C%20soft%20rose%20pink%20and%20warm%20cream%20color%20palette%2C%20dreamy%20soft%20focus%20lighting%2C%20elegant%20editorial%20magazine%20aesthetic%2C%20abstract%20backdrop%2C%20refined%20and%20harmonious%20mood&width=900&height=1100&seq=natsume-hero-01&orientation=portrait"
                  alt="夏目彩春 个人资料封面示意图"
                  title="夏目彩春 个人资料与动态追踪"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 left-4 md:left-8 bg-background-50 rounded-xl border border-background-200 px-4 py-3 shadow-sm max-w-[220px]">
                <div className="flex items-center gap-2">
                  <span className="w-9 h-9 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className="ri-alarm-warning-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">
                      信息以官方为准
                    </p>
                    <p className="text-[11px] text-foreground-600 mt-0.5">
                      网传内容仅作参考
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}